var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D8FBF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3332 15.9998C22.3332 19.4976 19.4976 22.3332 15.9998 22.3332C12.5021 22.3332 9.6665 19.4976 9.6665 15.9998C9.6665 12.502 12.5021 9.6665 15.9998 9.6665C18.5969 9.6665 20.8289 11.2297 21.8062 13.4665M22.3332 11.6665L22.0165 13.7832L19.9998 13.3332",
    stroke: "#11B989",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 15.3333V14.3333C14.6665 13.597 15.2634 13 15.9998 13C16.7362 13 17.3332 13.597 17.3332 14.3333V15.3333M15.4998 19H16.4998C17.2817 19 17.6726 19 17.9419 18.7933C18.0112 18.7401 18.0733 18.6781 18.1265 18.6087C18.3332 18.3395 18.3332 17.9485 18.3332 17.1667C18.3332 16.3848 18.3332 15.9939 18.1265 15.7246C18.0733 15.6553 18.0112 15.5932 17.9419 15.54C17.6726 15.3333 17.2817 15.3333 16.4998 15.3333H15.4998C14.718 15.3333 14.3271 15.3333 14.0577 15.54C13.9884 15.5932 13.9264 15.6553 13.8732 15.7246C13.6665 15.9939 13.6665 16.3848 13.6665 17.1667C13.6665 17.9485 13.6665 18.3395 13.8732 18.6087C13.9264 18.6781 13.9884 18.7401 14.0577 18.7933C14.3271 19 14.718 19 15.4998 19Z",
    stroke: "#11B989",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.0fd0b99ab1373f710e29b75239688a7b.svg";
export { ForwardRef as ReactComponent };